import { render, staticRenderFns } from "./the.vue?vue&type=template&id=381273db&"
import script from "./the.vue?vue&type=script&lang=ts&"
export * from "./the.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports